import type { Building } from '../world/city';

/** Exterior selection is conservative for roof slopes and stepped footprints. */
export function exteriorCellMask(b: Building): Set<number> {
  const stride = Math.max(b.w, b.d) + 2;
  const rows = new Map<number, [number, number]>(), cols = new Map<number, [number, number]>(), tops = new Map<number, number>();
  for (const cell of b.cells) {
    const row = cell.y * stride + cell.z, col = cell.y * stride + cell.x, top = cell.x + stride * cell.z;
    const xr = rows.get(row) ?? [Infinity, -Infinity], zr = cols.get(col) ?? [Infinity, -Infinity];
    xr[0] = Math.min(xr[0], cell.x); xr[1] = Math.max(xr[1], cell.x); rows.set(row, xr);
    zr[0] = Math.min(zr[0], cell.z); zr[1] = Math.max(zr[1], cell.z); cols.set(col, zr);
    tops.set(top, Math.max(tops.get(top) ?? -1, cell.y));
  }
  const mask = new Set<number>();
  for (const cell of b.cells) {
    const xr = rows.get(cell.y * stride + cell.z)!, zr = cols.get(cell.y * stride + cell.x)!;
    const courtyard = [[1, 0], [-1, 0], [0, 1], [0, -1]].some(([dx, dz]) =>
      cell.y > (tops.get(cell.x + dx + stride * (cell.z + dz)) ?? -1));
    // All roof layers matter: a slope's visible face can straddle two voxels.
    if (cell.y === 0 || cell.role === 'roof' || cell.y === tops.get(cell.x + stride * cell.z) ||
      cell.x === xr[0] || cell.x === xr[1] || cell.z === zr[0] || cell.z === zr[1] || courtyard) mask.add(cell.id);
  }
  return mask;
}
